/* Joyeux Marché — module « féerie » (30/10). Sans dépendance, respecte « animations réduites ».
   1. Boule à neige du hero : on la secoue, la neige s'envole sur toute la page (via window.JMSnow de jm-noel.js).
   2. La guirlande de l'en-tête s'illumine en vague à chaque ajout au panier réussi.
   3. Le village du pied de page s'allume quand on l'atteint, et le bonhomme de neige salue.
   4. Boutons du hero « aimantés » par la souris.
   5. Jours spéciaux : pluie d'étoiles dorées les 24 et 25/12, feu d'artifice du 31/12 au 2/1 (une fois par visite).
   6. Black Friday : le 3e cadeau s'ouvre quand le bloc apparaît.
   En aperçu du thème, ?jm_date=2026-12-24 (ou 2026-12-31, 2026-11-24) simule la date. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var fine = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  function reduced() { return mq.matches || root.classList.contains('jm-reduced'); }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function monthDay() { return ((window.JM && JM.today) || 0) % 10000; }
  function onScreen(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < innerHeight; }

  /* Petite bulle d'info, lue aussi par les lecteurs d'écran */
  function toast(msg, ms) {
    var live = d.getElementById('jm-feerie-live');
    if (!live) {
      live = d.createElement('div'); live.id = 'jm-feerie-live'; live.className = 'jm-visually-hidden';
      live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); d.body.appendChild(live);
    }
    live.textContent = msg;
    var t = d.createElement('div'); t.className = 'jm-toast'; t.setAttribute('aria-hidden', 'true'); t.textContent = msg;
    d.body.appendChild(t);
    setTimeout(function () { t.remove(); }, ms || 6000);
  }

  /* 1. Boule à neige */
  function globe() {
    var g = d.querySelector('[data-jm-globe]'); if (!g) return;
    var shakes = 0, timer = 0;
    g.addEventListener('click', function () {
      if (reduced()) return;
      g.classList.remove('has-hint', 'is-shaking'); void g.offsetWidth; g.classList.add('is-shaking');
      clearTimeout(timer); timer = setTimeout(function () { g.classList.remove('is-shaking'); }, 3000);
      var r = g.getBoundingClientRect();
      if (window.JMSnow) JMSnow.gust(r.left + r.width / 2, r.top + r.height * 0.35, innerWidth < 750 ? 50 : 90, innerWidth < 750 ? 50 : 110);
      shakes++; sset('jm_globe', '1');
      var md = monthDay();
      if (shakes === 3 && md >= 1101 && md <= 1224) toast('Psst… 5 lutins se cachent dans la boutique. Retrouve-les tous pour gagner la livraison offerte !', 7000);
    });
    /* Invitation discrète, une seule fois par visite */
    if (!sget('jm_globe') && !reduced()) {
      setTimeout(function () {
        if (!onScreen(g) || g.classList.contains('is-shaking') || sget('jm_globe')) return;
        sset('jm_globe', 'hint');
        g.classList.add('has-hint');
        setTimeout(function () { g.classList.remove('has-hint'); }, 5000);
      }, 4000);
    }
  }

  /* 2. Guirlande en fête à chaque ajout au panier */
  var partyT = 0;
  function garlandPrep() { d.querySelectorAll('.jm-guirlande .jm-bulb').forEach(function (b, i) { b.style.setProperty('--i', i); }); }
  function garlandParty() {
    if (reduced()) return;
    var g = d.querySelector('.jm-guirlande'); if (!g) return;
    g.classList.remove('is-party'); void g.getBoundingClientRect(); g.classList.add('is-party');
    clearTimeout(partyT); partyT = setTimeout(function () { g.classList.remove('is-party'); }, 2600);
  }
  d.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.action !== 'add' || !e.promise || !e.promise.then) return;
    e.promise.then(function (r) { if (r && r.detail && r.detail.didError) return; garlandParty(); }, function () {});
  });

  /* 3. Village du pied de page */
  function footVillage() {
    var v = d.querySelector('.jm-foot-village'); if (!v) return;
    if (!('IntersectionObserver' in window)) { v.classList.add('is-lit'); return; }
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      io.disconnect(); v.classList.add('is-lit');
      if (reduced()) return;
      setTimeout(function () { v.classList.add('is-waving'); setTimeout(function () { v.classList.remove('is-waving'); }, 1800); }, 1600);
    }, { threshold: 0.5 });
    io.observe(v);
  }

  /* 4. Boutons aimantés (souris uniquement) */
  function magnets() {
    if (!fine.matches) return;
    d.querySelectorAll('.jm-hero, .jm-bf-block').forEach(function (zone) {
      var btns = [].slice.call(zone.querySelectorAll('.jm-btn')); if (!btns.length) return;
      btns.forEach(function (b) { b.classList.add('jm-magnet'); });
      var raf = 0, px = 0, py = 0;
      function reset() { btns.forEach(function (b) { b.style.removeProperty('--mx'); b.style.removeProperty('--my'); }); }
      function upd() {
        raf = 0;
        if (reduced()) { reset(); return; }
        btns.forEach(function (b) {
          var r = b.getBoundingClientRect(), dx = px - (r.left + r.width / 2), dy = py - (r.top + r.height / 2);
          if (Math.abs(dx) - r.width / 2 < 36 && Math.abs(dy) - r.height / 2 < 28) {
            b.style.setProperty('--mx', Math.max(-9, Math.min(9, dx * 0.16)).toFixed(1) + 'px');
            b.style.setProperty('--my', Math.max(-6, Math.min(6, dy * 0.22)).toFixed(1) + 'px');
          } else if (b.style.getPropertyValue('--mx')) { b.style.removeProperty('--mx'); b.style.removeProperty('--my'); }
        });
      }
      zone.addEventListener('pointermove', function (e) { if (e.pointerType !== 'mouse') return; px = e.clientX; py = e.clientY; if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
      zone.addEventListener('pointerleave', reset);
    });
  }

  /* 5. Jours spéciaux */
  function starRain(hero) {
    var h = hero.offsetHeight, n = innerWidth < 750 ? 22 : 40, GL = ['★', '✦', '✧', '★'];
    for (var i = 0; i < n; i++) {
      var s = d.createElement('span'); s.className = 'jm-star'; s.setAttribute('aria-hidden', 'true');
      s.textContent = GL[i % GL.length];
      s.style.setProperty('--x', (Math.random() * 100).toFixed(1) + '%');
      s.style.setProperty('--s', (10 + Math.random() * 14).toFixed(0) + 'px');
      s.style.setProperty('--t', (2.6 + Math.random() * 2).toFixed(2) + 's');
      s.style.setProperty('--dl', (Math.random() * 2.2).toFixed(2) + 's');
      s.style.setProperty('--dx', (Math.random() * 80 - 40).toFixed(0) + 'px');
      s.style.setProperty('--fall', (h * (0.55 + Math.random() * 0.4)).toFixed(0) + 'px');
      s.style.setProperty('--r', (Math.random() * 360 - 180).toFixed(0) + 'deg');
      hero.appendChild(s);
    }
    setTimeout(function () { hero.querySelectorAll('.jm-star').forEach(function (s) { s.remove(); }); }, 5400);
  }
  function fireworks(hero) {
    var cv = d.createElement('canvas'); cv.className = 'jm-fireworks'; cv.setAttribute('aria-hidden', 'true');
    var stars = hero.querySelector('.jm-hero__stars');
    hero.insertBefore(cv, stars ? stars.nextSibling : hero.firstChild);
    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = hero.clientWidth, H = hero.clientHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var COLORS = ['#F6C768', '#FBF7EF', '#E5484D', '#7FD1A4', '#C99A3B'];
    var rockets = [], parts = [], launched = 0, total = innerWidth < 750 ? 6 : 9, t0 = 0, next = 0, last = 0;
    function launch() {
      rockets.push({ x: W * (0.15 + Math.random() * 0.7), y: H * 0.92, vy: -(7 + Math.random() * 3), ty: H * (0.1 + Math.random() * 0.3), c: COLORS[(Math.random() * COLORS.length) | 0] });
      launched++;
    }
    function explode(r) {
      var n = 46 + ((Math.random() * 20) | 0);
      for (var i = 0; i < n; i++) {
        var a = (i / n) * 6.283 + Math.random() * 0.2, sp = 1.5 + Math.random() * 3.3;
        parts.push({ x: r.x, y: r.y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1, c: Math.random() < 0.25 ? '#FBF7EF' : r.c });
      }
    }
    function frame(t) {
      if (!t0) t0 = t;
      var k = last ? Math.min(3, (t - last) / 16.7) : 1; last = t;
      if (launched < total && t >= next) { launch(); next = t + 550 + Math.random() * 650; }
      ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = 'rgba(0,0,0,.28)'; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      var i, r, p;
      for (i = rockets.length - 1; i >= 0; i--) {
        r = rockets[i]; r.y += r.vy * k; r.vy *= Math.pow(0.985, k);
        ctx.fillStyle = r.c; ctx.fillRect(r.x - 1, r.y, 2, 6);
        if (r.y <= r.ty || r.vy > -1) { explode(r); rockets.splice(i, 1); }
      }
      for (i = parts.length - 1; i >= 0; i--) {
        p = parts[i]; p.vx *= Math.pow(0.97, k); p.vy = p.vy * Math.pow(0.97, k) + 0.035 * k;
        p.x += p.vx * k; p.y += p.vy * k; p.life -= 0.012 * k;
        if (p.life <= 0) { parts.splice(i, 1); continue; }
        ctx.globalAlpha = p.life; ctx.fillStyle = p.c; ctx.beginPath(); ctx.arc(p.x, p.y, 1.6, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if ((launched >= total && !rockets.length && !parts.length) || t - t0 > 15000) { cv.remove(); return; }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function specialDays() {
    if (reduced()) return;
    var hero = d.querySelector('.jm-hero'); if (!hero) return;
    var md = monthDay();
    if ((md === 1224 || md === 1225) && !sget('jm_stars')) {
      sset('jm_stars', '1');
      setTimeout(function () { starRain(hero); }, 900);
      var sl = hero.querySelector('.jm-sleigh');
      if (sl) setTimeout(function () { sl.classList.remove('is-flying'); void sl.getBoundingClientRect(); sl.classList.add('is-flying'); }, 2600);
    }
    if ((md >= 1231 || (md >= 101 && md <= 102)) && !sget('jm_fw')) {
      sset('jm_fw', '1');
      setTimeout(function () { fireworks(hero); }, 800);
    }
  }

  /* 6. Black Friday : le 3e cadeau s'ouvre */
  function trio() {
    var t = d.querySelectorAll('.jm-trio'); if (!t.length) return;
    if (!('IntersectionObserver' in window)) { t.forEach(function (x) { x.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: 0.4 });
    t.forEach(function (x) { io.observe(x); });
  }

  window.JMFeerie = { party: garlandParty, toast: toast };

  function init() { garlandPrep(); globe(); footVillage(); magnets(); specialDays(); trio(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
